import { RolesMap } from '@/models/user'
import { RouteRecordRaw } from 'vue-router'
import BillModule from './BillModule.vue'
import ListBills from './views/ListBills.vue'
import CreateBill from './views/CreateBill.vue'
import ShowBill from './views/ShowBill.vue'
import EditBill from './views/EditBill.vue'

const routes: RouteRecordRaw[] = [
  {
    path: '/bills',
    component: BillModule,
    meta: { authorize: [RolesMap.EMPLOYEE_ROLE] },
    children: [
      {
        path: '',
        name: 'ListBills',
        component: ListBills,
        meta: { authorize: [RolesMap.EMPLOYEE_ROLE] }
      },
      {
        path: 'new',
        name: 'CreateBill',
        component: CreateBill,
        meta: { authorize: [RolesMap.EMPLOYEE_ROLE] }
      },
      {
        path: ':id',
        name: 'ShowBill',
        component: ShowBill,
        meta: { authorize: [RolesMap.EMPLOYEE_ROLE] }
      },
      {
        path: 'edit/:id',
        name: 'EditBill',
        component: EditBill,
        meta: { authorize: [RolesMap.EMPLOYEE_ROLE] }
      }
    ]
  }
]

export default routes
